import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FranchiseService } from 'src/app/services/FranchiseService';
import { FranchiseStatus , ReferenceTypes,FranchiseTypes,CrTypes } from 'src/app/franchise-app-global';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss'],
  providers: [FranchiseService]
})
export class FranchiseQrCodeComponent implements OnInit {
  qrValue: string | null = null;
  qrCodeDetails:any  
franchiseStatusEnum = FranchiseStatus;
referenceTypesEnum = ReferenceTypes;
franchiseTypesEnum = FranchiseTypes;
crTypesEnum = CrTypes;
  constructor(private route: ActivatedRoute , private franchiseService : FranchiseService ,private translate: TranslateService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const lang = params.get('lang') || 'ar';
      
      this.translate.use(lang);
    });
  
    this.route.queryParamMap.subscribe(params => {
      const rawQr = params.get('qr');
      if (rawQr) {
        this.qrValue = decodeURIComponent(rawQr);
        console.log(this.qrValue)
        this.franchiseService.getQrCodeDetails(this.qrValue).subscribe((res=>{
          this.qrCodeDetails =res
                    console.log(this.qrCodeDetails)

        }))

      }
    });
  }
}
